var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:['uw-users-avatar', _vm.type ]},[(_vm.src)?_c('img',{staticClass:"uw-users-avatar-src",attrs:{"src":_vm.src}}):_c('div',{staticClass:"uw-users-avatar-text"},[_vm._v(_vm._s(_vm.name[0]))]),_c('span',[_vm._v(_vm._s(_vm.name))])])
}
var staticRenderFns = []

export { render, staticRenderFns }